<template>
  <div class="h-full flex justify-center items-center bg-[#f7faff]">
    <div class="login-ctn w-[480px] text-center rounded-md">
      <div class="text-black text-3xl mb-11 font-semibold">
        {{ $t('deviationWritingSystem') }}
      </div>
      <n-form class="text-left" :model="form">
        <n-form-item-row>
          <n-input
            :placeholder="$t('login.enterAccount')"
            v-model:value="form.account"
            data-test="account"
            @keydown.enter="login"
          />
        </n-form-item-row>
      </n-form>
      <n-button
        type="primary"
        block
        strong
        class="mt-[30px]"
        :disabled="!form.account"
        @click="login"
        :loading="loading"
      >
        {{ $t('login.login') }}
      </n-button>
    </div>
    <div class="text-xs text-gray-light fixed bottom-10">
      深圳市司普科技有限公司技术提供
    </div>
  </div>
</template>

<script setup lang="ts">
import { useLoginStore } from '@/store'
import { useRequest } from '@/utils/hooks'
import { DIALOG, SETTINGS, AGENT, EVALUATION } from '@/router'

const loginStore = useLoginStore()
const router = useRouter()
const route = useRoute()
const form = ref({
  account: ''
})
const [login, loading] = useRequest(async () => {
  // console.log(form.value)
  const { account: username } = form.value
  let permissions = await loginStore.login({
    username
  })
  if (permissions.length) {
    const redirect = route.query.redirect
    if (redirect) {
      let failure = await router.push({
        path: redirect as string
      })
      if (!failure) return
    }
    if (permissions.includes(DIALOG)) {
      router.push({
        name: 'dialog'
      })
    } else if (permissions.includes(EVALUATION)) {
      router.push({
        name: 'audit'
      })
    } else if (permissions.includes(SETTINGS)) {
      router.push({
        name: 'system-setting'
      })
    } else if (permissions.includes(AGENT)) {
      router.push({
        name: 'estimate-standard'
      })
    }
  }
})
</script>

<style scoped>
.login-ctn {
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.3);
  padding: 40px 60px 70px;
}
</style>
